import { Loading } from 'components/Loading/Loading'

import classes from './FlowStatsExplorer.module.scss'

export const LoadingFlowExplorer = () => (
  <div className={classes.LoadingContainer}>
    <Loading data-testid="flowStats-loading-container" />
  </div>
)
